import Link from 'next/link'

export const titleAndText: Record<string, { title: string; text: JSX.Element }> = {
  students: {
    title: 'Students',
    text: (
      <>
        Canary Mission investigates hatred on the far-right, far-left and by anti-Israel activists.
        Every student profile has been carefully researched and sourced.
      </>
    ),
  },
  professors: {
    title: 'Professors',
    text: (
      <>
        Every professor on the Canary Mission database has been carefully researched. All
        information is gathered from publicly available sources.
      </>
    ),
  },
  professionals: {
    title: 'Professionals',
    text: (
      <>
        A list of professional employees who have displayed antisemitism either while employed or at
        college.
      </>
    ),
  },
  Canada: {
    title: 'Canada',
    text: (
      <>
        Canary Mission investigates hatred on the far-right, far-left and by anti-Israel activists.
        Every Canada profile has been carefully researched and sourced.
      </>
    ),
  },
  medical: {
    title: 'medical',
    text: (
      <>
        All profile subjects in the Medical List have shown themselves to warrant inclusion based on
        the requirements that can be viewed on our{' '}
        <Link href={'/ethics_policy'} className="text-[#337ab7]">
          Ethics Policy
        </Link>{' '}
        page.
      </>
    ),
  },
}
